'use client';
import { useRef } from 'react';
import { createUserStore, UserContext } from '@/store/user';
import { I18nLoad } from '@/components/Locale';
import { useRedirect } from '@/locale/hooks';
import { createI18nStore, I18nContext, setI18nStore } from '@spot-fe/base-ui';

export const Provider = ({
  children,
  locale,
  messages,
}: {
  children: React.ReactNode;
  messages?: Record<string, string>;
  locale: string;
}) => {
  const store = useRef(createUserStore()).current;
  const i18nStore = useRef(
    createI18nStore({ messages: messages || {}, locale })
  ).current;

  // 挂载全局的 i18nStore
  setI18nStore(i18nStore);

  useRedirect();
  return (
    <I18nContext.Provider value={i18nStore}>
      <UserContext.Provider value={store}>
        <I18nLoad>{children}</I18nLoad>
      </UserContext.Provider>
    </I18nContext.Provider>
  );
};
